import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { ApiService } from "../../services/api.service";
import { NgxSpinnerService } from "ngx-spinner";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmedValidator } from '../../services/confirmed.validator';
@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit {
  createPasswordForm:any;
  submitted = false;
  password:string='';closeResult: any = '';suucessMsgCreatePass:any='';
  re_password:string='';
  userId:any='';userType:any='';
  constructor(private auth:ApiService,
    private route: ActivatedRoute,
    private router: Router,private spinner: NgxSpinnerService,private formbuilder:FormBuilder,private modalService: NgbModal) {

    this.createPasswordForm = this.formbuilder.group({
      // Validators.pattern("/^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/")
        password: ['',[Validators.required,Validators.minLength(5),Validators.maxLength(10)]],
        re_password: ['',Validators.required] 
    },{
      validator: ConfirmedValidator('password', 're_password')
      });
    }
    ngOnInit(): void {
      this.route.queryParams.subscribe(queryParams => {
        this.userId = queryParams['id'];
        this.userType = queryParams['type'];
      });
      this.checkCreatePasword( this.userId);
    }
    checkCreatePasword(userId:any){
        this.auth.checkPassword(userId).subscribe(
          (data) => {
            if(data.status == 201 && data.message == 1 ){
              alert('Your link is expired');
              if(this.userType ==1){
                this.router.navigate(['/']);
              }else{
                this.router.navigate(['/admin-login']);
              }
              
            }
          },
          (error) => {
           
          },
        );
      
    }
    open(content: any) {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
    get f() { return this.createPasswordForm.controls; }
    changePass(form:any){
      //this.token = this.route.snapshot.params.token;
      this.submitted = true;
       //stop here if form is invalid
       if (this.createPasswordForm.invalid) {
             return;
       }
       this.spinner.show();
      this.password=this.createPasswordForm.controls.password.value;
       this.auth.createPassword(this.userId,this.password).subscribe(
         data => {
           console.log(data);
              if(data.status == 200){
                this.suucessMsgCreatePass = 'Your password has been created. Please login.';
                document.getElementById('successMsg')?.click();
              if(this.userType == 2){
                this.router.navigate(['/admin-login']);
              }else{
                this.router.navigate(['/']);
              }
               
               this.spinner.hide();
               }else if(data.status == 404){
                this.spinner.hide();
            }
         },
         error => {
          //alert(error);
        });  
   }
  

}
